import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["tag", "target", "rel"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("a", {
    class: _normalizeClass(["c-text-link", [_ctx.customizeColorClass, { 'c-text-link--has_line': _ctx.hasUnderline }]]),
    tag: _ctx.tag,
    target: _ctx.isLinkTag && _ctx.blank ? '_blank' : '_self',
    rel: _ctx.isLinkTag && _ctx.blank ? 'noopener noreferrer' : '',
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.emitClickEvent && _ctx.emitClickEvent(...args)))
  }, [
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ], 10, _hoisted_1))
}